import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
// Female names from LATAM, USA, and Europe
const FEMALE_NAMES = [
// LATAM
'Valentina', 'Camila', 'Sofía', 'Daniela', 'Mariana', 'Gabriela', 'Laura', 'Paula', 'Juliana', 'Fernanda', 'Alejandra', 'Catalina', 'Andrea', 'Natalia', 'Karla', 'Ximena', 'Lucía', 'Renata', 'Isabela', 'Sara', 'Carolina', 'Melissa',
// USA
'Emily', 'Sarah', 'Jessica', 'Ashley', 'Amanda', 'Megan', 'Lauren', 'Natalie', 'Olivia', 'Sophia', 'Isabella', 'Hannah', 'Chloe', 'Madison', 'Emma',
// Europe
'Emma', 'Sofia', 'Lucia', 'Martina', 'Valeria', 'Giulia', 'Anna', 'Elena', 'Clara', 'Noa', 'Mia', 'Lara', 'Nina', 'Eva', 'Julia'];
const getRandomPrice = () => {
  const min = 8.97;
  const max = 26.97;
  return (Math.random() * (max - min) + min).toFixed(2);
};
const getRandomName = (usedNames: Set<string>) => {
  const availableNames = FEMALE_NAMES.filter(name => !usedNames.has(name));
  // If all names used, reset
  if (availableNames.length === 0) {
    usedNames.clear();
    return FEMALE_NAMES[Math.floor(Math.random() * FEMALE_NAMES.length)];
  }
  return availableNames[Math.floor(Math.random() * availableNames.length)];
};
const getLastInitial = (name: string) => {
  const lastInitials = ['A', 'B', 'C', 'D', 'F', 'G', 'H', 'L', 'M', 'P', 'R', 'S', 'T', 'V', 'Z'];
  return lastInitials[Math.floor(Math.random() * lastInitials.length)];
};
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentPrice, setCurrentPrice] = useState('');
  const [usedNames] = useState(new Set<string>());
  const generateNewPopup = () => {
    const name = getRandomName(usedNames);
    usedNames.add(name);
    const initial = getLastInitial(name);
    setCurrentName(`${name} ${initial}.`);
    setCurrentPrice(getRandomPrice());
  };
  useEffect(() => {
    // First popup: 6-10 seconds after mount
    const initialDelay = Math.random() * (10000 - 6000) + 6000;
    const showFirstPopup = setTimeout(() => {
      generateNewPopup();
      setIsVisible(true);
      // Hide after 5-7 seconds
      const visibleDuration = Math.random() * (7000 - 5000) + 5000;
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next popup 9-18 seconds after hiding
        scheduleNextPopup();
      }, visibleDuration);
    }, initialDelay);
    return () => clearTimeout(showFirstPopup);
  }, []);
  const scheduleNextPopup = () => {
    const nextDelay = Math.random() * (18000 - 9000) + 9000;
    setTimeout(() => {
      generateNewPopup();
      setIsVisible(true);
      // Hide after 5-7 seconds
      const visibleDuration = Math.random() * (7000 - 5000) + 5000;
      setTimeout(() => {
        setIsVisible(false);
        scheduleNextPopup();
      }, visibleDuration);
    }, nextDelay);
  };
  const handleClose = () => {
    setIsVisible(false);
    scheduleNextPopup();
  };
  return <AnimatePresence data-id="element-223">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 max-w-[320px]" data-id="element-224">
          <div className="bg-gradient-to-br from-[#1a4731] to-[#0f291e] rounded-xl shadow-2xl border border-brand-green/30 overflow-hidden" data-id="element-225">
            <div className="flex items-center gap-3 p-3 relative" data-id="element-226">
              {/* Close button */}
              <button onClick={handleClose} className="absolute top-2 right-2 text-white/60 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-227">
                <X className="w-4 h-4" data-id="element-228" />
              </button>

              {/* Mini image */}
              <div className="flex-shrink-0" data-id="element-229">
                <img src="https://cdn.magicpatterns.com/uploads/ktuDCM4PB5ddUfAehAf3Q2/Producto_Principal.png" alt="Quincena en Verde" className="w-16 h-16 rounded-lg object-cover border-2 border-brand-green/20" data-id="element-230" />
              </div>

              {/* Content */}
              <div className="flex-1 pr-4" data-id="element-231">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-232">
                  <div className="w-2 h-2 bg-brand-green rounded-full" data-id="element-233"></div>
                  <span className="text-[10px] font-bold text-brand-gold uppercase tracking-wider" data-id="element-234">
                    Compra reciente
                  </span>
                </div>
                <p className="text-white font-semibold text-sm mb-0.5" data-id="element-235">
                  {currentName}
                </p>
                <p className="text-white/70 text-xs" data-id="element-236">
                  Edición digital • ${currentPrice} USD
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}